import React from "react";
import { ProfileHeaderCardComponent } from "../../../services/types/ComponentTypes";
import { ComponentRenderer } from "../../ComponentRenderer";

interface ProfileHeaderCardProps {
    component: ProfileHeaderCardComponent;
    formData: any;
    handleFormDataChange: (fieldName: string, value: any) => void;
    handleActionTrigger: (action: any) => void;
}

const ProfileHeaderCard: React.FC<ProfileHeaderCardProps> = ({
    component,
    formData,
    handleFormDataChange,
    handleActionTrigger,
}) => {
    // Cast style to any to bypass the specific type mismatch with FlexDirection enum vs string
    const containerStyle = { ...component.style, display: "flex", alignItems: "center" } as React.CSSProperties;

    return (
        <div style={containerStyle}>
            {component.fields?.map((field: any, index: number) => {
                if (field.name === "profile_avatar") {
                    return (
                        <div key={index} style={{ marginRight: 20 }}>
                            <img
                                src={formData[field.BindValue] || "https://via.placeholder.com/150"}
                                alt="Profile Avatar"
                                style={{
                                    width: 100,
                                    height: 100,
                                    borderRadius: "50%",
                                    objectFit: "cover",
                                    backgroundColor: "#e0e0e0",
                                }}
                            />
                        </div>
                    );
                }
                return null;
            })}

            <div style={{ flex: 1 }}>
                {component.fields?.map((field: any, index: number) => {
                    if (field.name !== "profile_avatar") {
                        const value = formData[field.BindValue];
                        const style: React.CSSProperties = {
                            color: "#fff",
                            marginBottom: 4,
                        };

                        if (field.name === "profile_name") {
                            style.fontSize = 24;
                            style.fontWeight = "bold";
                        } else {
                            style.fontSize = 14;
                            style.opacity = 0.9;
                        }

                        return (
                            <div key={index} style={style}>
                                {value || "-"}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>
        </div>
    );
};

export default ProfileHeaderCard;
